import { redirect } from 'next/navigation';

import { getUiConfig } from '@/config/client/getUiConfig';
import { AUTH_COOKIE } from '@/constants/cookies';
import { cookieManager } from '@/sdk/client/cookieManager';

import { userStore } from '../userStore';

const uiConfig = getUiConfig();

export const statefulRefreshToken: Foxkit.StatefulRefreshTokenOptions = {
  authCookieName: AUTH_COOKIE,
  authCookieDomain:
    process.env.NODE_ENV !== 'development' &&
    !(typeof window !== 'undefined' && window.location.hostname.includes('dev-ond'))
      ? uiConfig.authCookieDomain
      : undefined,
  onAccessTokenUpdated: (authData?: Foxkit.UserCookie) => {
    userStore.set(authData);
  },
  onRefreshError: (error: { message: string; statusCode: number }) => {
    const { statusCode } = error;

    console.error(`[CentralizedLogin][statefulRefreshTokenOptions][onRefreshError] error ${statusCode}`, error);

    redirect('/logout');
  },

  cookieManager,
  use: true,
};
